// A one-number staleness signal for the kept-alive engine views.
//
// Keep-alive stops the views being torn down, but if each one refetches
// everything in activated() the round trips come straight back — a tab switch
// still costs ~8 reads on 홈 even when nothing happened. Equally, never
// refetching means a finished session or a watched clip does not show up when
// the member returns, which is the thing they actually notice.
//
// So: every engine WRITE bumps a counter. A view records the counter when it
// loads and, on re-activation, refetches only if the number moved (or if the
// data is older than the floor, which catches changes made on another device).
let version = 0;

/** Called by the services after any write that a surface might be showing. */
export function markEngineDirty() {
  version += 1;
  return version;
}

/** Older than this and we refetch regardless — another device may have written. */
export const STALE_FLOOR_MS = 120000;

/**
 * @param {{version:number, at:number}|null} stamp taken when the view last loaded
 * @returns {boolean} should this view refetch now?
 */
export function shouldRefresh(stamp, nowMs = Date.now()) {
  if (!stamp) return true;
  if (stamp.version !== version) return true;
  return nowMs - stamp.at >= STALE_FLOOR_MS;
}

/** Stamp to store after a successful load. */
export function stampNow(nowMs = Date.now()) {
  return { version, at: nowMs };
}

/** Test seam only. */
export function __resetEngineBus() {
  version = 0;
}
